'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledText = require('../styled-text');

var _styledText2 = _interopRequireDefault(_styledText);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _util = require('../util');

var _proptypes = require('../util/proptypes');

require('./hover-link.scss');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var HoverLink = function HoverLink(props) {
  var autoFocus = props.autoFocus,
      children = props.children,
      className = props.className,
      containerClassName = props.containerClassName,
      href = props.href,
      _props$target = props.target,
      target = _props$target === undefined ? '_self' : _props$target,
      onPress = props.onPress,
      onClick = props.onClick,
      style = props.style,
      _props$tabIndex = props.tabIndex,
      tabIndex = _props$tabIndex === undefined ? 0 : _props$tabIndex,
      testid = props.testid,
      _props$text = props.text,
      text = _props$text === undefined ? children : _props$text,
      rest = _objectWithoutProperties(props, ['autoFocus', 'children', 'className', 'containerClassName', 'href', 'target', 'onPress', 'onClick', 'style', 'tabIndex', 'testid', 'text']);

  var clickFunction = onClick ? onClick : onPress;
  var customHref = href || '#';
  var linkElement = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (autoFocus && linkElement) {
      linkElement.current.focus();
    }
  });

  if (typeof text === 'string') {
    return _react2.default.createElement('a', _extends({
      autoFocus: autoFocus,
      href: customHref,
      target: target,
      className: (0, _classnames2.default)(_defineProperty({
        'zk-hover-link-container': true
      }, containerClassName, !!containerClassName)),
      'data-testid': 'HOVER_LINK_CONTAINER',
      onClick: function onClick(e) {
        !href && e.preventDefault();
        clickFunction(e);
      },
      onKeyDown: function onKeyDown(e) {
        return (0, _util.basicKeyToggle)(e, clickFunction);
      },
      ref: linkElement,
      style: style,
      tabIndex: tabIndex
    }, rest), _react2.default.createElement(_styledText2.default, {
      className: (0, _classnames2.default)(_defineProperty({
        'zk-hover-link': true
      }, className, !!className)),
      testid: testid
    }, text));
  } else {
    //if ever we are looking for clickable icon, we should probably style as <Button transparent/> or
    //<HoverIcon/> rather than using <HoverLink/>. This is a fallback for improper usage of hover-link
    return _react2.default.createElement('a', _extends({
      autoFocus: autoFocus,
      className: (0, _classnames2.default)(_defineProperty({
        'zk-hover-link-container': true
      }, containerClassName, !!containerClassName)),
      'data-testid': 'HOVER_LINK_CONTAINER',
      href: customHref,
      onClick: function onClick(e) {
        !href && e.preventDefault();
        clickFunction(e);
      },
      onKeyDown: function onKeyDown(e) {
        return (0, _util.basicKeyToggle)(e, clickFunction);
      },
      ref: linkElement,
      style: style,
      tabIndex: tabIndex,
      target: target
    }, rest), text);
  }
};

HoverLink.propTypes = {
  className: _propTypes2.default.string,
  containerClassName: _propTypes2.default.string,
  href: _propTypes2.default.string,
  onPress: _propTypes2.default.func,
  style: _proptypes.STYLE_PROP,
  testid: _propTypes2.default.string,
  text: _propTypes2.default.string
};
exports.default = HoverLink;